module.exports = __webpack_public_path__ + "static/media/bin-purple.355d7b17.svg";